"use client";

import * as React from "react";
import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
  useTheme,
} from "next-themes";

function BootThemeSync() {
  const { resolvedTheme } = useTheme();

  React.useEffect(() => {
    if (resolvedTheme === "light" || resolvedTheme === "dark") {
      document.documentElement.dataset.bootTheme = resolvedTheme;
    }
  }, [resolvedTheme]);

  return null;
}

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider {...props}>
      <BootThemeSync />
      {children}
    </NextThemesProvider>
  );
}
